import { render, staticRenderFns } from "./Shop-in-shop.vue?vue&type=template&id=10f99894&scoped=true&"
import script from "./Shop-in-shop.vue?vue&type=script&lang=js&"
export * from "./Shop-in-shop.vue?vue&type=script&lang=js&"
import style0 from "./Shop-in-shop.vue?vue&type=style&index=0&id=10f99894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f99894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
